import React, { useState } from 'react';
import { dayString } from '../../../utils/recordDate';
import createRecord from '../../../api/services/createRecord';
import { useNavigate } from 'react-router-dom';
import getSources from '../../../api/resources/getSources';
import getServiceStatuses from '../../../api/services/getServiceStatuses';

// components
import Header from '../../../components/Header/Header';
import Form from '../../../components/Form/Form';
import Button from '../../../components/Button/Button';
import Breadcrumbs from '../../../components/Breadcrumbs';
import Loader from '../../../components/Loader/Loader';
import Alert from '../../../components/Alert/Alert';
import SelectClients from '../../../components/Selects/SelectClients';
import SelectManagers from '../../../components/Selects/SelectManagers';
import SelectServiceStatuses from '../../../components/Selects/SelectServiceStatuses';
import Datepicker from '../../../components/Inputs/Datepicker/Datepicker';
import SelectSources from '../../../components/Selects/SelectSources';
import SelectServices from '../../../components/Selects/SelectServices';
import Select from '../../../components/Select/Select';
import HookForm from '../../../components/HookForm/HookForm';

// icons
import icon from '../../../brand/generated/sidebar/records.svg';
import alert from '../../../helpers/alert';

const formStyles = {
  record: { display: 'grid', gap: '20px', gridTemplateAreas: `'a a k k' 'b b b b' 'c c c c' 'd d n n' 'f f f f'` },
};

const AddRecordPurchase = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = React.useState({});
  const [succes, setSucces] = React.useState({});
  const [service, setService] = useState([
    // { name: 'disabled_date', type: 'input', label: 'ÐÐ°ÑÐ°', value: '01.11.2022', disabled: true },
    // { name: 'id', type: 'input', label: 'ID', value: '35567809', disabled: true },
    {
      name: 'userId',
      component: SelectClients,
      label: 'ÐÐ»Ð¸ÐµÐ½Ñ',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      style: { gridArea: 'k' },
      rules: { required: true },
    },
    {
      name: 'statuse',
      component: SelectServiceStatuses,
      label: 'Ð¡ÑÐ°ÑÑÑ Ð·Ð°Ð¿Ð¸ÑÐ¸',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      rules: { required: true },
    },
    {
      name: 'sourceId',
      label: 'ÐÑÑÐ¾ÑÐ½Ð¸Ðº',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      component: SelectSources,
      rules: { required: true },
    },
    {
      name: 'created_at',
      type: 'date',
      value: new Date(),
      label: 'ÐÐ°ÑÐ°',
      component: Datepicker,
      rules: { required: true },
    },
    {
      name: 'time',
      component: Select,
      label: 'ÐÑÐµÐ¼Ñ',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      options: [
        { value: '09:00', label: '09:00' },
        { value: '10:30', label: '10:30' },
        { value: '12:00', label: '12:00' },
        { value: '13:30', label: '13:30' },
        { value: '15:00', label: '15:00' },
        { value: '16:30', label: '16:30' },
      ],
      rules: { required: true },
    },
    // {
    //   name: 'services',
    //   component: SelectServices,
    //   label: 'Ð£ÑÐ»ÑÐ³Ð°',
    //   placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
    //   style: { gridArea: 'c' },
    //   isMulti: true,
    //   isSearchable: true,
    //   rules: { required: true },
    // },
    {
      name: 'address',
      component: Select,
      label: 'ÐÐ´ÑÐµÑ Ð´Ð¸Ð»ÐµÑÑÐºÐ¾Ð³Ð¾ ÑÐµÐ½ÑÑÐ°',
      options: [{ value: 'ÐÐ´ÑÐµÑ', label: 'ÐÐ´ÑÐµÑ' }],
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      style: { gridArea: 'n' },
    },
    {
      name: 'managerId',
      component: SelectManagers,
      label: 'ÐÑÐ²ÐµÑÑÑÐ²ÐµÐ½Ð½ÑÐ¹ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      style: { gridArea: 'd' },
    },
    {
      name: 'comment',
      type: 'input',
      label: 'ÐÐ°Ð¼ÐµÑÐºÐ¸/ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¸ Ð¾ Ð·Ð°Ð¿Ð¸ÑÐ¸',
      placeholder: 'ÐÑÑÐ°Ð²ÑÑÐµ Ð²Ð°Ñ ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¹',
      style: { gridArea: 'f' },
    },
  ]);

  const addRecord = (data) => {
    setLoading(true);
    const day = dayString(data?.created_at);
    const time = data?.time?.value;
    const payload = {
      sourceId: data?.sourceId?.value,
      services: data?.services?.map((item) => ({ id: item.value })),
      date: day + ' ' + time + ':00',
      typeId: 4,
      userId: data?.userId?.value,
    };

    createRecord(payload)
      .then((res) => {
        setSucces({ message: 'ÐÐ°Ð¿Ð¸ÑÑ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð°' });
        setTimeout(() => {
          navigate('/records');
        }, 1000);
      })
      .catch((error) => {
        alert.error(error.response.data.errorMessage ?? JSON.stringify(error.response))
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      {loading && <Loader />}
      <div style={{ paddingBottom: '20px' }}>
        <Header title="ÐÐ¾Ð²Ð°Ñ Ð·Ð°Ð¿Ð¸ÑÑ Ð½Ð° Ð²ÑÐºÑÐ¿ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ" icon={icon} />
        <Breadcrumbs navigate={'/records'} link={'ÐÐ°Ð¿Ð¸ÑÐ¸'} currentPage={'ÐÐ¾Ð²Ð°Ñ Ð·Ð°Ð¿Ð¸ÑÑ'} />
        <HookForm
          inputs={service}
          handlerSetState={setService}
          title={'ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ Ð·Ð°Ð¿Ð¸ÑÐ¸'}
          grid={formStyles.record}
          border
          action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð·Ð°Ð¿Ð¸ÑÑ'}
          onSubmit={addRecord}
        />
      </div>
      {error.message && <Alert message={error.message} onClick={setError} />}
      {succes.message && <Alert message={succes.message} />}
    </>
  );
};

export default AddRecordPurchase;
